import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from "@material-ui/core/TextField";
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import React, { Component } from 'react';
import Button from 'react-bootstrap-button-loader';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import { sortActivityByCode } from '../../actions/timesheet/activity';
import { sortDepartmentByCode } from '../../actions/timesheet/department';
import { sortJobTitleByCode } from '../../actions/timesheet/jobTitle';
import { sortProjectByCode } from '../../actions/timesheet/project';
import { sortSubCodesByCode, subCodesCCQTimesheet } from '../../actions/timesheet/subCode';
import { tasksTimesheet, sortTasksByCode } from '../../actions/timesheet/task';
import { paramDefault } from '../../actions/timesheet/paramDefault';
import { paramPayment } from '../../actions/timesheet/paramPayment';
import { saveTimesheet, deleteTimesheet, get, loadCombos, getDuration } from '../../actions/timesheet';
import * as statusDelete from '../../scripts/StatusDeleteTimesheet';
import { GetABCUsage } from '../../utils/companyConfig';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { format } from 'react-string-format';
import TimeTextField from '../controls/TimeTextField';
import DecimalTextField from '../controls/DecimalTextField';
import * as utils from '../../utils';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Popup } from "@progress/kendo-react-popup";
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { GetLanguage, IsEnglish } from '../../utils/language';
import * as storage from '../../utils/storage';
import { loadLocalization } from '../../utils/kendoLocalization';
import Switch from '@material-ui/core/Switch'
import AlertAlgo from '../controls/AlertSnack';
import moment from "moment";
import "moment/locale/fr";
import * as bench from '../../utils/benchmark';
import styles from '../../styles/timesheet.module.css';

loadLocalization();
moment.locale("fr");

const TimeControls = (props) => {
    return (
        <FormControl fullWidth>
            <TimeTextField
                id="startTime"
                name="startTime"
                label={i18next.t('timesheet:form.from')}
                onBlur={props.onChangeStartTime}
                className={styles.inputStartTime}
                value={props.startTime}
                onFocus={props.handleFocus}
                disabled={!props.canModify}
                placeholder="HH:MM"
            />

            <TimeTextField
                id="endTime"
                name="endTime"
                label={i18next.t('timesheet:form.to')}
                onBlur={props.onChangeEndTime}
                className={styles.inputEndTime}
                value={props.endTime}
                onFocus={props.handleFocus}
                disabled={!props.canModify}
                placeholder="HH:MM"
            />
        </FormControl>
    )
};

class TimesheetForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorForm: true,
            abcUsage: true,
            linkProjectPActivity: false,
            companyPayProject: false,
            companyPayActivity: false,
            companyPayTask: false,
            useTime: storage.getUseTimeTimesheet(),
            useTimeRequired: storage.getUseTimeTimesheetRequired(),
            isActive: true,
            listComplete: [],
            projects: [],
            activities: [],
            departments: [],
            projectsPay: [],
            activitiesPay: [],
            subCodes: [],
            subCodesCCQ: [],
            subCodesFinal: [],
            taskPay: [],
            jobTitles: [],
            jobTitlesCCQ: [],
            ccqSalariesTable: [],
            ccqPrimeTypes: [],
            profilesSubCode: [],
            profileProjects: [],
            profileDepartments: [],
            profileJobTitles: [],
            profileEmployee: [],
            profilesJobTitle: [],
            profilesPayProject: [],
            materialResources: [],
            projectDefault: '',
            projectPDefault: '',
            activityDefault: '',
            activityPDefault: '',
            departmentDefault: '',
            subCodeDefault: '',
            jobTitleDefault: '',
            taskDefault: '',
            targetDate: props.targetDate != null ? utils.convertToDate(props.targetDate) : new Date(),
            startTime: null,
            endTime: null,
            duration: 0,
            project: '',
            projectPay: '',
            activity: '',
            activityPay: '',
            subCode: '',
            subCodeOld: '',
            subCodeCCQOld: '',
            task: '',
            department: '',
            jobTitle: '',
            jobTitleCCQ: null,
            ccqSalaryTable: null,
            ccqPrimeType: null,
            ccqRegion: '',
            ccqSector: '',
            comments: '',
            isPostCompleted: true,
            isDeleteCompleted: true,
            isResetCompleted: true,
            canModify: true,
            timesheetId: props.timesheetId,
            openConfirmDelete: false,
            openConfirmReset: false,
            locale: "fr",
            isCCQParam: storage.getIsCCQ(),
            isCCQ: false,
            isPayCodePremium: false
        };

        this.alert = React.createRef();
    }

    async componentDidMount() {
        if (this.state.timesheetId == 0 && this.state.targetDate == null) {
            this.setState({ targetDate: utils.formatDate(new Date().toISOString(), 'date') }).then(() => {
                this.loadMaterialResource();
            });
        }

        const language = GetLanguage();

        moment.locale(language);
        this.setState({ locale: language });

        await this.loadParamDefault();
        await this.loadParamPay();
        await this.loadTimesheet();
        await this.loadDropDowns();

        this.resizeForm();
    }

    resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;

            const elemHeader = document.querySelector('[data-id=headerTimesheetForm]');

            const header = elemHeader != null ? document.querySelector('[data-id=headerTimesheetForm]').offsetHeight : 0;
            const offSet = 80;

            const customHeight = height - header - offSet;

            const element = document.querySelector('#divForm');

            if (element != null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
        }, 1000);
    }

    onLoadSummary = () => {
        this.props.onLoadSummary();
    }

    onCloseForm = () => {
        this.props.onCloseForm();
    }

    onCloseDetail = () => {
        this.props.onCloseDetail();
    }

    onCloseEditTimesheet = (message) => {
        this.props.onCloseEditTimesheet(message, this.state.targetDate);
    }

    onChangeAppBarDate = (date) => {
        this.props.onChangeDate(date);
    }

    handleFocus = (event) => {
        // this should be good on desktop and android
        //event.target.select();

        // workaround to make it work in iOS
        event.target.setSelectionRange(0, event.target.value.length);
    }

    loadTimesheet = () => {
        return new Promise(resolve => {
            if (this.state.timesheetId > 0) {
                get(this.state.timesheetId).then((response) => {
                    const list = JSON.parse(response.list);

                    let startTime = utils.formatDate(list.startDate, 'time');
                    let endTime = utils.formatDate(list.endDate, 'time');

                    if (startTime == endTime) {
                        if (startTime == '00:00') {
                            startTime = null;
                            endTime = null;
                        }
                    }

                    this.setState(
                        {
                            targetDate: utils.formatDate(list.startDate, 'date'),
                            duration: list.duration,
                            subCode: list.sc || '',
                            project: list.projectAbc || '',
                            projectPay: list.projectCode || '',
                            activity: list.activityProject,
                            activityPay: list.activityPay,
                            department: list.department || '',
                            task: list.taskCode || '',
                            jobTitle: list.jobTitle || '',
                            jobTitleCCQ: list.jobTitleCCQCode || '',
                            comments: list.comment || '',
                            startTime: startTime,
                            endTime: endTime,
                            canModify: (!list.supervisorId > 0) || this.state.timesheetId == 0,
                            isCCQ: list.isCCQ === 'O',
                            ccqSalaryTable: list.salaryCCQCode,
                            ccqPrimeType: list.typeCCQPrimeCode
                        }, () => {
                            this.onChangeAppBarDate(list.startDate);
                            resolve();
                        });
                });
            }
            else {
                resolve();
            }
        });
    }

    loadParamDefault = () => {
        return new Promise((resolve) => {
            paramDefault().then((result) => {
                const param = JSON.parse(result.param);

                this.setState({
                    // We will use this default params to clear the page
                    projectDefault: param.projectDef,
                    projectPDefault: param.projectPDef,
                    activityDefault: param.activityDef,
                    activityPDefault: param.activityPDef,
                    departmentDefault: param.departmentDef,
                    taskDefault: param.taskDef,
                    jobTitleDefault: param.jobTitleDef,
                    subCodeDefault: param.subCodeDef,

                    project: param.projectDef,
                    projectP: param.projectPDef,
                    activity: param.activityDef,
                    activityP: param.activityPDef,
                    department: param.departmentDef,
                    task: param.taskDef,
                    jobTitle: param.jobTitleDef,
                    subCode: param.subCodeDef,

                    abcUsage: GetABCUsage(),
                    linkProjectPActivity: storage.getLinkProjectPActivity()
                }, () => {
                    resolve();
                });
            });
        });
    }

    loadParamPay = () => {
        return new Promise((resolve) => {
            paramPayment().then((result) => {
                const param = JSON.parse(result.param);

                this.setState({
                    companyPayProject: param.projectPay,
                    companyPayActivity: param.activityPay,
                    companyPayTask: param.taskPay
                }, () => {
                    resolve();
                });
            });
        });
    }

    loadDropDowns = () => {
        return new Promise(async (resolve) => {
            var response = await loadCombos();

            if (response != null) {
                this.setState({ listComplete: JSON.parse(response.result) }, async () => {
                    await this.loadProfileJobTitle();
                    await this.loadProfilePayProject();
                    await this.loadProfileSubCode();
                    await this.loadDepartments();
                    await this.loadJobTitles();
                    await this.loadProjects();
                    await this.loadActivities();
                    await this.loadTasks();
                    await this.loadJobTitleCCQ();
                    if (this.state.timesheetId > 0 && this.state.isCCQ) {
                        await this.loadSubcodesCCQ(false);
                        await this.loadSalaryTableCCQ();
                        await this.loadPrimeTypeCCQ();
                        this.setState({ isPayCodePremium: this.state.subCodesFinal.filter(x => x.sc == this.state.subCode)[0]?.isPremium });
                    }
                    else {
                        await this.loadSubcodes();
                    }
                    this.setState({ isActive: false });
                    resolve();
                });
            }
            else {
                this.showMessageError(i18next.t('error:generic-error'));
                this.setState({ isActive: false });
                resolve();
            }
        })
    }

    loadProfileSubCode = () => {
        return new Promise(resolve => {
            this.setState({
                profilesSubCode: this.state.listComplete.profileSubCodeResult.profilesSubCode,
                profileProjects: this.state.listComplete.profileSubCodeResult.projects,
                profileDepartments: this.state.listComplete.profileSubCodeResult.departments,
                profileJobTitles: this.state.listComplete.profileSubCodeResult.jobTitles,
                profileEmployee: this.state.listComplete.profileSubCodeResult.employeeProfile
            }, () => resolve());
        });
    }

    loadProjects = () => {
        return new Promise(async (resolve) => {
            if (!this.state.abcUsage && !this.state.companyPayProject) {
                this.setState({ project: '', projectP: '' });
                resolve();
                return;
            }

            let list;

            if (this.state.companyPayProject) {
                list = await this.handleProfilePayProject();
            } else {
                list = this.state.listComplete.projects;
            }

            if (this.state.isCCQ) {
                list = list.filter(x => x.ccqRegion !== null && x.ccqSector !== null);
            }

            let defaultProject = this.state.companyPayProject ? this.state.projectPay : this.state.project;

            if (defaultProject === null || defaultProject === '') {
                defaultProject = this.state.companyPayProject ? this.state.projectPDefault : this.state.projectDefault;
            }

            // This is to avoid setting a project value in the save if no match project is found on the list
            const isMatch = list.filter(item => item.project === defaultProject);

            if (isMatch.length <= 0) {
                defaultProject = '';
            }

            this.setState(
                {
                    projects: sortProjectByCode(list),
                    project: this.state.companyPayProject ? '' : defaultProject,
                    projectPay: this.state.companyPayProject ? defaultProject : ''
                }, () => {
                    this.selectRegionProject();
                    resolve()
                });
        })
    }

    selectRegionProject = async () => {
        let ccqRegion = null;
        let ccqSector = null;

        if (this.state.abcUsage || this.state.companyPayProject) {
            const objProject = await this.state.projects.filter(x => x.project == (this.state.abcUsage ? this.state.project : this.state.projectPay))[0];
            if (objProject) {
                ccqRegion = objProject.ccqRegion;
                ccqSector = objProject.ccqSector;
            }
            this.setState({ ccqRegion: ccqRegion, ccqSector: ccqSector });
        }
    }

    loadActivities = () => {
        return new Promise((resolve) => {
            if (!this.state.abcUsage && !this.state.companyPayActivity) {
                this.setState({ activity: '', activityP: '' });
                resolve();
                return;
            }

            const project = this.state.companyPayProject ? this.state.projectPay : this.state.project;

            let list = this.state.listComplete.activities;

            if (this.state.abcUsage || (this.state.companyPayProject && this.state.linkProjectPActivity)) {
                list = list?.filter(item => item.project == project);
            }

            let defaultActivity = this.state.companyPayActivity ? this.state.activityPay : this.state.activity;

            if (defaultActivity === null || defaultActivity === '') {
                defaultActivity = this.state.companyPayActivity ? this.state.activityPDefault : this.state.activityDefault;
            }

            // This is to avoid setting an activity value in the save if no match activity is found on the list
            const isMatch = list?.filter(item => item.activity == defaultActivity);

            if (isMatch?.length <= 0) {
                defaultActivity = '';
            }

            this.setState(
                {
                    activities: sortActivityByCode(list),
                    activity: this.state.companyPayActivity ? '' : defaultActivity.toString(),
                    activityPay: this.state.companyPayActivity ? defaultActivity : ''
                }, () => {
                    resolve();
                });
        });
    }

    loadDepartments = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.departments;

            let defaultDepartment = this.state.department;

            if (defaultDepartment === null || defaultDepartment === '') {
                defaultDepartment = this.state.departmentDefault;
            }

            this.setState({ departments: sortDepartmentByCode(list), department: defaultDepartment }, () => {
                resolve();
            });
        })
    }

    loadJobTitles = () => {
        return new Promise(async (resolve) => {
            //const list = this.state.listComplete.jobs;
            const list = await this.handleProfileJobTitle();

            let defaultJobTitles = this.state.jobTitle;

            if (defaultJobTitles === null || defaultJobTitles === '') {
                defaultJobTitles = this.state.jobTitleDefault;
            }

            // This is to avoid setting a job title value in the save if no match job title is found on the list
            const isMatch = list?.filter(item => item.jc === defaultJobTitles);

            if (isMatch?.length <= 0) {
                defaultJobTitles = '';
            }

            this.setState({ jobTitles: sortJobTitleByCode(list), jobTitle: defaultJobTitles }, () => {
                resolve();
            });
        })
    }

    loadSubcodes = (isLoadFromCCQ = false) => {
        return new Promise(async (resolve) => {
            //const list = this.state.listComplete.subCodes;

            // Filter by profile sub-code
            let list = await this.handleProfileSubCode();

            let defaultSubCode = this.state.subCode;

            if (isLoadFromCCQ) {
                this.setState({ subCodeCCQOld: defaultSubCode });
            }

            if (defaultSubCode === null || defaultSubCode === '') {
                defaultSubCode = this.state.subCodeDefault;
            }

            // This is to avoid setting a sub-code value in the save if no match sub-code is found on the list
            let isMatch = list.filter(item => item.sc == defaultSubCode);

            if (isMatch.length <= 0) {
                if (defaultSubCode !== this.state.subCodeDefault) {
                    isMatch = list.filter(item => item.sc == this.state.subCodeDefault);
                    if (isMatch.length <= 0) {
                        defaultSubCode = '';
                    }
                    else {
                        defaultSubCode = this.state.subCodeDefault;
                    }
                }
                else {
                    defaultSubCode = '';
                }
            }

            this.setState({ subCodes: list, subCode: defaultSubCode, subCodesFinal: list }, () => {
                resolve();
            });
        })
    }

    loadSubcodesCCQ = (isSaveOld = true) => {
        return new Promise(async (resolve) => {
            if (isSaveOld) {
                const subCodeOld = this.state.subCode;
                this.setState({ subCodeOld: subCodeOld, subCode: null });
            }

            if (this.state.subCodeCCQOld != null && this.state.subCodeCCQOld != '') {
                this.setState({ subCode: this.state.subCodeCCQOld });
            }

            const list = await subCodesCCQTimesheet(this.state.project, this.state.jobTitle, this.state.department);

            this.setState({ subCodesFinal: list }, () => resolve());
        })
    }

    loadProfileJobTitle = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.profilesJobTitle;

            this.setState(
                {
                    profilesJobTitle: list
                }, () => resolve());
        });
    }

    loadProfilePayProject = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.profilesPayProject;

            this.setState(
                {
                    profilesPayProject: list
                }, () => resolve());
        });
    }

    handleProfileSubCode = () => {
        return new Promise(resolve => {
            let list = this.state.listComplete.subCodes;

            let profileIds = [];

            let filterSubCodes = [];

            const filterEmployee = [];

            const filterProject = [];

            const filterDepartment = [];

            const filterJobTitle = [];

            // 1 - We get all profiles sub code from each category (Employee/Worksite - Project - Department - JobTitle)

            const profileEmployee = this.state.profileEmployee;

            const profileProject = this.state.profileProjects.filter(item => item.project === this.state.project);

            const profileDepartment = this.state.profileDepartments.filter(item => item.department === this.state.department);

            const profileJobTitle = this.state.profileJobTitles.filter(item => item.jobTitle === this.state.jobTitle);

            // 2 - We list all sub-codes from each profile by category

            // Employee/Worksite
            profileEmployee.forEach(item => profileIds.push(item.profileSubCodeDisplayId))

            this.state.profilesSubCode.filter(item => profileIds.includes(item.profileSubCodeDisplayId))
                .forEach(item => filterEmployee.push(item.subCode))

            // Project
            // Reset profileIds
            profileIds = [];

            profileProject.forEach(item => profileIds.push(item.profileSubCodeDisplayId))

            this.state.profilesSubCode.filter(item => profileIds.includes(item.profileSubCodeDisplayId))
                .forEach(item => filterProject.push(item.subCode));

            // Department
            // Reset profileIds
            profileIds = [];

            profileDepartment.forEach(item => profileIds.push(item.profileSubCodeDisplayId));

            this.state.profilesSubCode.filter(item => profileIds.includes(item.profileSubCodeDisplayId))
                .forEach(item => filterDepartment.push(item.subCode));

            // JobTitle
            // Reset profileIds
            profileIds = [];

            profileJobTitle.forEach(item => profileIds.push(item.profileSubCodeDisplayId));

            this.state.profilesSubCode.filter(item => profileIds.includes(item.profileSubCodeDisplayId))
                .forEach(item => filterJobTitle.push(item.subCode));

            // 3 - We join all sub-codes in one list
            filterSubCodes = filterEmployee.concat(filterProject).concat(filterDepartment).concat(filterJobTitle);

            // Distinct sub-codes
            filterSubCodes = Array.from(new Set(filterSubCodes));

            // 4 - We return only the sub-codes that are common in all lists (categories) if they have profile
            filterSubCodes = filterSubCodes.filter(x =>
                (filterEmployee.length > 0 ? filterEmployee.includes(x) : true)
                && (filterProject.length > 0 ? filterProject.includes(x) : true)
                && (filterDepartment.length > 0 ? filterDepartment.includes(x) : true)
                && (filterJobTitle.length > 0 ? filterJobTitle.includes(x) : true))

            if (filterSubCodes.length > 0) {
                list = list.filter(item => filterSubCodes.includes(item.sc));
            } else if (filterEmployee.length > 0 || filterDepartment.length > 0 || filterProject.length > 0 || filterJobTitle.length > 0) {
                resolve([]);
                return;
            }

            resolve(list);
        });
    }

    handleProfileJobTitle = () => {
        return new Promise(resolve => {
            let list = this.state.listComplete.jobs;

            const filterJobTitle = [];

            this.state.profilesJobTitle?.filter(item => item.department == this.state.department)
                .forEach(item => filterJobTitle.push(item.jobTitle))

            if (list?.length > 0 && filterJobTitle?.length > 0) {
                list = list.filter(item => filterJobTitle.includes(item.jc));
            }

            resolve(list);
        });
    }

    handleProfilePayProject = () => {
        return new Promise(resolve => {
            let list = this.state.listComplete.projectsP;

            const filterPayProject = [];

            this.state.profilesPayProject?.filter(item => item.department == this.state.department)
                .forEach(item => filterPayProject.push(item.projectId))

            if (list?.length > 0 && filterPayProject?.length > 0) {
                list = list.filter(item => filterPayProject.includes(item.sequenceId));
            }

            resolve(list);
        });
    }

    loadTasks = () => {
        return new Promise((resolve) => {
            if (this.state.companyPayTask) {
                tasksTimesheet(this.state.activityPay, this.state.activity, this.state.projectPay).then((result) => {
                    if (result !== undefined) {
                        this.setState({ taskPay: sortTasksByCode(JSON.parse(result.tasks)) }, () => {
                            resolve();
                        });
                    }
                    else {
                        resolve();
                    }
                });
            }
            else {
                resolve();
            }
        });
    }

    loadJobTitleCCQ = () => {
        return new Promise((resolve) => {
            if (this.state.isCCQParam) {
                let list = this.state.listComplete.ccqJobTitles;

                list = list?.filter(x => new Date(x.startDate) <= new Date()
                    && (x.endDate == null || new Date(x.endDate) >= new Date()));

                this.setState(
                    {
                        jobTitlesCCQ: list
                    }, () => resolve());
            }
            else {
                resolve();
            }
        });
    }

    loadSalaryTableCCQ = () => {
        return new Promise((resolve) => {
            if (this.state.isCCQ && this.state.jobTitleCCQ) {
                let list = this.state.listComplete.ccqSalaryTables;

                list = list.filter(x => x.ccqFunctionId == this.state.jobTitleCCQ
                    && x.ccqSector == this.state.ccqSector
                    && new Date(x.startDate) <= new Date()
                    && (x.endDate == null || new Date(x.endDate) >= new Date()));

                this.setState(
                    {
                        ccqSalariesTable: list
                    }, () => resolve());
            }
            else {
                resolve();
            }
        });
    }

    loadPrimeTypeCCQ = () => {
        return new Promise((resolve) => {
            if (this.state.isCCQ) {
                const list = this.state.listComplete.primeTypes;

                const listFiltered = list.filter(x => (x.ccqFunctionId == this.state.jobTitleCCQ || x.ccqFunctionId == null)
                    && (x.ccqRegion == this.state.ccqRegion || x.ccqRegion == null)
                    && (x.salaryTable == this.state.ccqSalaryTable || x.salaryTable == null)
                    && (x.subcode == this.state.subCode)
                    && new Date(x.startDate) <= new Date()
                    && (x.endDate == null || new Date(x.endDate) >= new Date())
                    || x.primeIndicator == '99'
                );

                let formattedList = [];

                listFiltered.forEach(x => {
                    formattedList.push({
                        primeIndicator: x.primeIndicator,
                        descriptionTypePrimeE: x.descriptionTypePrimeE,
                        descriptionTypePrimeF: x.descriptionTypePrimeF
                    });
                });

                // Need to do a distinct
                let result = formattedList.filter(function (obj) {
                    var key = obj.primeIndicator + '|' + obj.descriptionTypePrimeE + '|' + obj.descriptionTypePrimeF
                    if (!this[key]) {
                        this[key] = true
                        return true;
                    }
                }, Object.create(null));

                this.setState(
                    {
                        ccqPrimeTypes: result
                    }, () => resolve());
            }
            else {
                resolve();
            }
        });
    }

    reset = (event) => {
        return new Promise((resolve) => {
            this.setState({
                isActive: true,
                projects: [],
                activities: [],
                departments: [],
                projectsPay: [],
                activitiesPay: [],
                subCodes: [],
                taskPay: [],
                jobTitles: [],
                startTime: '',
                endTime: '',
                duration: 0,
                project: this.state.projectDefault,
                projectPay: this.state.projectPDefault,
                activity: this.state.activityDefault,
                activityPay: this.state.activityPDefault,
                subCode: this.state.subCodeDefault,
                task: this.state.taskDefault,
                department: this.state.departmentDefault,
                jobTitle: this.state.jobTitleDefault,
                isCCQ: false,
                comments: '',
            }, async () => {
                await this.loadDropDowns();
                resolve();
            });
        });
    }

    onDateChange = (event) => {
        this.setState({ targetDate: event.target.value }, () => {
            this.onChangeAppBarDate(event.target.value);
        });
    }

    onChangeStartTime = (event) => {
        const start = utils.formatTime(event.target.value);

        this.setState({ startTime: start }, () => {
            this.calculateDuration();
        });
    }

    onChangeEndTime = (event) => {
        const end = utils.formatTime(event.target.value);

        this.setState({ endTime: end }, () => {
            this.calculateDuration();
        });
    }

    calculateDuration = () => {
        const isValidTime = this.validateTime();

        if (this.state.useTimeRequired && isValidTime) {
            const start = new Date(`${this.state.targetDate} ${this.state.startTime}`);
            const end = new Date(`${this.state.targetDate} ${this.state.endTime}`);

            const diff = utils.timeDiffCalcDecimal(end, start);

            this.setState({ duration: diff });
        } else if (this.state.useTimeRequired && !isValidTime) {
            this.setState({ duration: '' });
        }
    }

    validateTime = () => {
        const start = new Date(`${this.state.targetDate} ${this.state.startTime}`);
        const end = new Date(`${this.state.targetDate} ${this.state.endTime}`);

        const isNotStartValid = isNaN(start.getTime());
        const isNotEndValid = isNaN(end.getTime());

        let valid = true;

        if (isNotStartValid && this.state.startTime !== null && this.state.startTime.length == 5) {
            valid = false;

            setTimeout(() => { this.showMessageError(i18next.t('timesheet:message.startTimeError')) }, 250);
        } else if (isNotEndValid && this.state.endTime !== null && this.state.endTime.length == 5) {
            valid = false;

            setTimeout(() => { this.showMessageError(i18next.t('timesheet:message.endTimeError')) }, 250);
        }

        if (!isNotStartValid && !isNotEndValid) {
            if (this.state.startTime !== '' && this.state.endTime !== '' && end <= start) {
                valid = false;
                setTimeout(() => { this.showMessageError(i18next.t('timesheet:message.endTimeGreaterThanStartTimeError')) }, 250);
            }
        }

        return valid;
    }

    showMessageError = (msg) => {
        this.alert.current.showMessageError(msg);
    }

    onChangeDuration = (event) => {
        this.setState({ duration: event.target.value });
    }

    onChangeDepartment = (event) => {
        this.setState({ department: event.target.value }, () => {
            if (this.state.isCCQ) {
                this.loadSubcodesCCQ(false);
                this.loadJobTitleCCQ();
            } else {
                this.loadSubcodes();
                this.loadJobTitles();
            }

            if (this.state.companyPayProject) {
                this.loadProjects();
            }
        });
    }

    onChangeProject = (event) => {
        this.setState(
            {
                isActive: true,
                project: event.target.value
            }, async () => {
                await this.loadActivities();
                if (this.state.isCCQ) {
                    this.loadSubcodesCCQ(false);
                } else {
                    this.loadSubcodes();
                }
                await this.selectRegionProject();
                await this.loadPrimeTypeCCQ();
                await this.loadSalaryTableCCQ();
                await this.setState({ isActive: false });
            });
    }

    onChangeActivity = (event) => {
        this.setState({ activity: event.target.value }, () => {
            this.loadTasks();
        });
    }

    onChangeSubCode = (event) => {
        const subCode = event.target.value;

        const isPremium = this.state.subCodesFinal.filter(x => x.sc == subCode)[0].isPremium;

        this.setState({ subCode: event.target.value, isPayCodePremium: isPremium }, () => {
            if (!isPremium) {
                this.setState({ ccqPrimeType: null });
            }
            else {
                this.loadPrimeTypeCCQ();
            }
        });
    }

    onChangeProjectPay = (event) => {
        this.setState(
            {
                isActive: true,
                projectPay: event.target.value
            }, async () => {
                await this.loadActivities();
                if (this.state.isCCQ) {
                    this.loadSubcodesCCQ(false);
                } else {
                    this.loadSubcodes();
                }
                await this.loadTasks();
                await this.selectRegionProject();
                await this.loadPrimeTypeCCQ();
                await this.loadSalaryTableCCQ();
                await this.setState({ isActive: false });
            });
    }

    onChangeActivityPay = (event) => {
        this.setState({ activityPay: event.target.value }, () => {
            this.loadTasks();
        });
    }

    onChangeTask = (event) => {
        this.setState({ task: event.target.value });
    }

    onChangeJobTitle = (event) => {
        this.setState({ jobTitle: event.target.value }, () => {
            if (this.state.isCCQ) {
                this.loadSubcodesCCQ(false);
            } else {
                this.loadSubcodes();
            }
        });
    }

    onChangeJobTitleCCQ = (event) => {
        this.setState({ jobTitleCCQ: event.target.value }, () => {
            this.loadSalaryTableCCQ();
        });
    }

    onChangeCCQSalaryTable = (event) => {
        this.setState({ ccqSalaryTable: event.target.value }, () => {
            this.loadPrimeTypeCCQ();
        });
    }

    onChangeCCQPrimeType = (event) => {
        this.setState({ ccqPrimeType: event.target.value });
    }

    onChangeComments = (event) => {
        this.setState({ comments: event.target.value });
    }

    onChangeIsCCQ = (event) => {
        this.setState({ isCCQ: event.target.checked }, async () => {
            await this.loadProjects();

            if (this.state.isCCQ) {
                this.loadSubcodesCCQ();
            }
            else {
                await this.loadSubcodes(true);

                if (this.state.subCodeOld != null && this.state.subCodeOld != '') {
                    const subCodeOld = this.state.subCodeOld;
                    this.setState({ subCode: subCodeOld });
                }

                this.setState({ subCodesFinal: this.state.subCodes });
            }
            this.resizeForm();
        });
    }

    handleConfirmResetButtonClick = () => {
        this.setState({ openConfirmReset: true });
    }

    handleCloseConfirmReset = () => {
        this.setState({ openConfirmReset: false });
    }

    handleConfirmDelete = () => {
        this.setState({ openConfirmDelete: true });
    }

    handleCloseConfirmDelete = () => {
        this.setState({ openConfirmDelete: false });
    }

    handleSaveButtonClick = () => {
        this.setState({ isPostCompleted: false });

        this.validateForm().then(() => {
            if (!this.state.errorForm) {
                this.validateMaxHours().then(() => {
                    if (!this.state.errorForm) {
                        this.setState({ isActive: true });
                        saveTimesheet(this.state.timesheetId, utils.formatDate(this.state.targetDate, 'date'), utils.formatDate(this.state.targetDate, 'date'), utils.toDecimal(this.state.duration),
                            this.state.subCode, this.state.department, this.state.jobTitle, this.state.comments, this.state.project,
                            this.state.activity, this.state.activityPay, 'N', 'N', 'N', 'REGULAR', `${utils.formatDate(this.state.targetDate, 'date')}T${this.state.startTime || '00:00'}`, `${utils.formatDate(this.state.targetDate, 'date')}T${this.state.endTime || '00:00'}`,
                            this.state.projectPay, null, 'N', this.state.task, this.state.jobTitleCCQ, this.state.ccqSalaryTable,
                            this.state.ccqPrimeType, this.state.isCCQ).then((response) => {
                                if (response == undefined) {
                                    this.showMessageError(i18next.t('error:generic-error'));
                                    this.setState(
                                        {
                                            isPostCompleted: true,
                                            isActive: false
                                        }, () => {
                                            document.querySelector('#divForm').scrollTo(0, 0);
                                        });
                                    return;
                                }

                                if (response.status === false && response.errorMsg.length > 0) {
                                    this.showMessageError(response.errorMsg);

                                    this.setState(
                                        {
                                            isPostCompleted: true
                                        }, () => {
                                            document.querySelector('#divForm').scrollTo(0, 0);
                                        });
                                }
                                else if (response.status === true) {
                                    this.onLoadSummary();
                                    this.alert.current.showMessageSuccess(i18next.t('timesheet:message.success'));
                                    this.setState({ isPostCompleted: true });
                                    this.onCloseForm();
                                    if (this.state.timesheetId > 0) {
                                        this.onCloseDetail();
                                    }
                                    this.onCloseEditTimesheet(i18next.t('timesheet:message.success'));
                                }
                                this.setState({ isActive: false });
                            })
                            .catch(error => {
                                this.showMessageError(i18next.t('error:generic-error'));

                                this.setState(
                                    {
                                        isActive: false,
                                        isPostCompleted: true
                                    }, () => {
                                        document.querySelector('#divForm').scrollTo(0, 0);
                                    });
                            });
                    }
                })
            }
        });
    };

    handleResetButtonClick = () => {
        this.setState({ isResetCompleted: false, openConfirmReset: false, isActive: true });
        this.reset().then(() => {
            this.setState({ isResetCompleted: true });
        });
    }

    handleDeleteButtonClick = () => {
        this.setState({ isDeleteCompleted: false, openConfirmDelete: false });

        deleteTimesheet(this.state.timesheetId).then((response) => {
            let message = '';
            let error = false;
            response = JSON.parse(response.result);
            if (response.status == statusDelete.STATUS_OK) {
                this.onLoadSummary();
                this.onCloseForm();
                this.onCloseEditTimesheet(i18next.t('timesheet:message.delete'));
                this.setState({ isDeleteCompleted: true });
            }
            else if (response.status == statusDelete.STATUS_LEAVEREQUESTTIED) {
                message = i18next.t('timesheet:message.delete-leaveRequestTiedToEntry');
                error = true;
            }
            else if (response.status == statusDelete.STATUS_ALREADYAPPROVED) {
                message = i18next.t('timesheet:message.delete-alreadyApproved');
                error = true;
            }
            else {
                message = i18next.t('timesheet:message.generic-error');
                error = true;
            }

            if (error) {
                this.showMessageError(message);
            }

            this.setState({ errorForm: error, isDeleteCompleted: true });
        });
    }

    validateForm = () => {
        return new Promise((resolve) => {
            let message = '';
            let error = false;

            if (this.state.targetDate === null) {
                message = i18next.t('timesheet:message.targetDate-form');
                error = true;
            } else if (this.state.duration <= 0) {
                message = i18next.t('timesheet:message.duration-form');
                error = true;
            } else if ((this.state.abcUsage && (this.state.project === '' || this.state.project === null))
                || (this.state.companyPayProject && (this.state.projectPay === '' || this.state.projectPay === null))) {
                message = i18next.t('timesheet:message.project-form');
                error = true;
            } else if ((this.state.abcUsage && (this.state.activity === '' || this.state.activity === null))
                || (this.state.companyPayActivity && (this.state.activityPay === '' || this.state.activityPay === null))) {
                message = i18next.t('timesheet:message.activity-form');
                error = true;
            } else if (this.state.subCode === '' || this.state.subCode === null) {
                message = i18next.t('timesheet:message.payCode-form');
                error = true;
            } else if (this.state.department === '') {
                message = i18next.t('timesheet:message.department-form');
                error = true;
            } else if (this.state.jobTitle === '') {
                message = i18next.t('timesheet:message.jobTitle-form');
                error = true;
            } else if (this.state.duration === '') {
                message = i18next.t('timesheet:message.duration-form');
                error = true;
            } else if (this.state.isCCQ === true) {
                if (this.state.jobTitleCCQ === '' || this.state.jobTitleCCQ === null) {
                    message = i18next.t('timesheet:message.jobTitleCCQ-form');
                    error = true;
                } else if (this.state.ccqSalaryTable === '' || this.state.ccqSalaryTable === null) {
                    message = i18next.t('timesheet:message.salaryTable-form');
                    error = true;
                }
            }

            if (error) {
                this.showMessageError(message);
            } else {
                error = !this.validateTime();
            }

            this.setState({ isPostCompleted: true, errorForm: error }, () => {
                resolve();
            });
        })
    }

    validateMaxHours = () => {
        return new Promise(async (resolve) => {
            const response = await getDuration(utils.formatDate(this.state.targetDate, 'date'), this.state.timesheetId);

            if (response == null) {
                this.setState({ isPostCompleted: true, errorForm: true }, () => {
                    this.showMessageError(i18next.t('timesheet:message.generic-error'));
                    resolve();
                });
            } else {
                let message = '';
                let error = false;
                let durationDate = 0;

                durationDate = JSON.parse(response.duration)

                const maxDuration = parseFloat(durationDate) + parseFloat(this.state.duration);

                if (maxDuration > 24) {
                    message = i18next.t('timesheet:message.duration-error');
                    error = true;
                }

                if (error) {
                    this.showMessageError(message);
                }

                this.setState({ isPostCompleted: true, errorForm: error }, () => {
                    resolve();
                });
            }
        })
    }

    render() {
        let _el;
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('punch:form.loading')}
            >
                <div id="divForm" className={styles.rootTimesheetForm}>
                    {this.state.isCCQParam == true && <FormControl className={styles.switchComponent}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.isCCQ}
                                    onChange={this.onChangeIsCCQ}
                                    name="isCCQ"
                                    variant="success"
                                />
                            }
                            label={i18next.t("timesheet:form.isCCQ")}
                            labelPlacement="start"
                        />
                    </FormControl>}

                    {this.state.timesheetId == 0 &&
                        <div className={styles.divDate} ref={el => (_el = el)}>
                            <LocalizationProvider language={this.state.locale}>
                                <IntlProvider locale={this.state.locale}>
                                    <InputLabel className={styles.labelDate + " labelDatePicker required"} htmlFor="date">Date</InputLabel>
                                    <DatePicker
                                        className={styles.inputDate + ' required'}
                                        name="date"
                                        value={this.state.targetDate}
                                        onChange={this.onDateChange}
                                        format="yyyy-MM-dd"
                                        disabled={!this.state.canModify}
                                        popup={props => <Popup {...props} appendTo={_el} />} />
                                </IntlProvider>
                            </LocalizationProvider>
                        </div>
                    }

                    {this.state.useTime && this.state.useTimeRequired &&
                        <TimeControls
                            onChangeStartTime={this.onChangeStartTime}
                            onChangeEndTime={this.onChangeEndTime}
                            startTime={this.state.startTime}
                            endTime={this.state.endTime}
                            handleFocus={this.handleFocus}
                            canModify={this.state.canModify}
                            className={'required'}
                        />}

                    <FormControl fullWidth>
                        <DecimalTextField
                            id="duration"
                            name="duration"
                            label={i18next.t('timesheet:form.duration')}
                            handleChange={this.onChangeDuration}
                            className={styles.inputDuration + ' required'}
                            value={this.state.duration}
                            onFocus={this.handleFocus}
                            decimalScale={4}
                            disabled={!this.state.canModify}
                        >
                        </DecimalTextField>
                    </FormControl>

                    <FormControl fullWidth>
                        <div className={styles.divFormSelect}>
                            <InputLabel className={"required"} id="label-subCode">{i18next.t('timesheet:form.payCode')}</InputLabel>
                            <Select
                                labelId="label-subCode"
                                id="subCode"
                                value={this.state.subCode || ''}
                                onChange={this.onChangeSubCode}
                                disabled={!this.state.canModify}
                                MenuProps={{ classes: { paper: styles.selectList } }}
                            >
                                {this.state.subCodesFinal.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.sc}>{`${obj.sc} - ${IsEnglish() ? obj.scEn : obj.scFr}`}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>

                    <FormControl fullWidth>
                        <div className={styles.divFormSelect}>
                            <InputLabel id="label-department" className={"required"}>{i18next.t('timesheet:form.department')}</InputLabel>
                            <Select
                                labelId="label-department"
                                id="department"
                                value={this.state.department}
                                onChange={this.onChangeDepartment}
                                disabled={!this.state.canModify}
                                MenuProps={{ classes: { paper: styles.selectList } }}
                            >
                                {this.state.departments.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.depart}>{`${obj.depart} - ${IsEnglish() ? obj.departEn : obj.departFr}`}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>

                    <FormControl fullWidth>
                        <div className={styles.divFormSelect}>
                            <InputLabel id="label-jobTitle" className={"required"}>{i18next.t('timesheet:form.jobTitle')}</InputLabel>
                            <Select
                                labelId="label-jobTitle"
                                id="jobTitle"
                                value={this.state.jobTitle}
                                onChange={this.onChangeJobTitle}
                                disabled={!this.state.canModify}
                                MenuProps={{ classes: { paper: styles.selectList } }}
                            >
                                {this.state.jobTitles && this.state.jobTitles.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.jc}>{`${obj.jc} - ${IsEnglish() ? obj.jobEn : obj.jobFr}`}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>

                    {this.state.abcUsage &&
                        (
                            <FormControl fullWidth>
                                <div className={styles.divFormSelect}>
                                    <InputLabel id="label-project" className={"required"}>{i18next.t('timesheet:form.project')}</InputLabel>
                                    <Select
                                        className={styles.ddlTimesheetForm}
                                        labelId="label-project"
                                        id="project"
                                        value={this.state.project || ''}
                                        onChange={this.onChangeProject}
                                        disabled={!this.state.canModify}
                                        MenuProps={{ classes: { paper: styles.selectList } }}
                                    >
                                        {this.state.projects && this.state.projects.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>
                        )
                    }

                    {this.state.abcUsage &&
                        (
                            <FormControl fullWidth>
                                <div className={styles.divFormSelect}>
                                    <InputLabel id="label-activity" className={"required"}>{i18next.t('timesheet:form.activity')}</InputLabel>
                                    <Select
                                        labelId="label-activity"
                                        id="activity"
                                        value={this.state.activity || ''}
                                        onChange={this.onChangeActivity}
                                        disabled={!this.state.canModify}
                                        MenuProps={{ classes: { paper: styles.selectList } }}
                                    >
                                        {this.state.activities && this.state.activities.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.activity}>{`${obj.activity} - ${IsEnglish() ? obj.activityEn : obj.activityFr}`}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>
                        )
                    }

                    {this.state.companyPayProject &&
                        (
                            <FormControl fullWidth>
                                <div className={styles.divFormSelect}>
                                    <InputLabel id="label-project-pay" className={"required"}>{i18next.t('timesheet:form.project')}</InputLabel>
                                    <Select
                                        labelId="label-project-pay"
                                        id="projectPay"
                                        value={this.state.projectPay || ''}
                                        onChange={this.onChangeProjectPay}
                                        disabled={!this.state.canModify}
                                        MenuProps={{ classes: { paper: styles.selectList } }}
                                    >
                                        {this.state.projects && this.state.projects.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>
                        )
                    }

                    {this.state.companyPayActivity &&
                        (
                            <FormControl fullWidth>
                                <div className={styles.divFormSelect}>
                                    <InputLabel id="label-activity-pay" className={"required"}>{i18next.t('timesheet:form.activity')}</InputLabel>
                                    <Select
                                        labelId="label-activity-pay"
                                        id="activityPay"
                                        value={this.state.activityPay || ''}
                                        onChange={this.onChangeActivityPay}
                                        disabled={!this.state.canModify}
                                        MenuProps={{ classes: { paper: styles.selectList } }}
                                    >
                                        {this.state.activities && this.state.activities.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.activity}>{`${obj.activity} - ${IsEnglish() ? obj.activityEn : obj.activityFr}`}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>
                        )
                    }

                    {this.state.companyPayTask &&
                        (
                            <FormControl fullWidth>
                                <div className={styles.divFormSelect}>
                                    <InputLabel id="label-task" className={"required"}>{i18next.t('timesheet:form.task')}</InputLabel>
                                    <Select
                                        labelId="label-task"
                                        id="task"
                                        value={this.state.task || ''}
                                        onChange={this.onChangeTask}
                                        disabled={!this.state.canModify}
                                        MenuProps={{ classes: { paper: styles.selectList } }}
                                    >
                                        {this.state.taskPay && this.state.taskPay.map((obj, index) =>
                                            <MenuItem key={index} className={styles.selectItem} value={obj.taskCode}>{`${obj.taskCode} - ${IsEnglish() ? obj.taskEn : obj.taskFr}`}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </FormControl>
                        )
                    }

                    {this.state.isCCQ && <FormControl fullWidth>
                        <div className={styles.divFormSelect}>
                            <InputLabel id="label-jobTitleCCQ" className={"required"}>{i18next.t('timesheet:form.jobTitleCCQ')}</InputLabel>
                            <Select
                                labelId="label-jobTitleCCQ"
                                id="jobTitleCCQ"
                                value={this.state.jobTitleCCQ || ''}
                                onChange={this.onChangeJobTitleCCQ}
                                MenuProps={{ classes: { paper: styles.selectList } }}
                            >
                                {this.state.jobTitlesCCQ && this.state.jobTitlesCCQ.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.ccqFunctionId}>{`${obj.ccqFunctionId} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>}

                    {this.state.isCCQ && <FormControl fullWidth>
                        <div className={styles.divFormSelect}>
                            <InputLabel id="label-ccqSalaryTable" className={"required"}>{i18next.t('timesheet:form.salaryTableCCQ')}</InputLabel>
                            <Select
                                labelId="label-ccqSalaryTable"
                                id="ccqSalaryTable"
                                value={this.state.ccqSalaryTable || ''}
                                onChange={this.onChangeCCQSalaryTable}
                                className={'comboSalaryTable'}
                                MenuProps={{ classes: { paper: styles.selectList } }}
                            >
                                {this.state.ccqSalariesTable && this.state.ccqSalariesTable.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.salaryTableCode}>{`${obj.salaryTableCode} - ${IsEnglish() ? obj.salaryTableDescriptionE : obj.salaryTableDescriptionF}`}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>}

                    {this.state.isCCQ && this.state.isPayCodePremium && <FormControl fullWidth>
                        <div className={styles.divFormSelect}>
                            <InputLabel id="label-ccqPrimeType" className={"required"}>{i18next.t('timesheet:form.primeTypeCCQ')}</InputLabel>
                            <Select
                                labelId="label-ccqPrimeType"
                                id="primeTypes"
                                value={this.state.ccqPrimeType || ''}
                                onChange={this.onChangeCCQPrimeType}
                                MenuProps={{ classes: { paper: styles.selectList } }}
                            >
                                {this.state.ccqPrimeTypes && this.state.ccqPrimeTypes.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.primeIndicator}>{`${obj.primeIndicator} - ${IsEnglish() ? obj.descriptionTypePrimeE : obj.descriptionTypePrimeF}`}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>}

                    <FormControl fullWidth>
                        <TextField
                            id="comments"
                            label={i18next.t('timesheet:form.comments')}
                            multiline
                            minRows={4}
                            className={styles.inputComments}
                            onChange={this.onChangeComments}
                            disabled={!this.state.canModify}
                            value={this.state.comments || ''}
                        />
                    </FormControl>

                    {this.state.useTime && !this.state.useTimeRequired &&
                        <TimeControls
                            onChangeStartTime={this.onChangeStartTime}
                            onChangeEndTime={this.onChangeEndTime}
                            startTime={this.state.startTime}
                            endTime={this.state.endTime}
                            handleFocus={this.handleFocus}
                            canModify={this.state.canModify}
                        />}

                    <FormControl className={styles.divButtons}>
                        {this.state.canModify &&
                            <Button
                                loading={!this.state.isPostCompleted}
                                className={styles.saveButton}
                                disabled={this.state.loading}
                                onClick={this.handleSaveButtonClick}
                                variant="success"
                            >
                                {i18next.t('timesheet:button.save')}
                            </Button>
                        }

                        {this.state.timesheetId == 0 &&
                            <Button
                                loading={!this.state.isResetCompleted}
                                className="resetButton"
                                onClick={this.handleConfirmResetButtonClick}
                                variant="success"
                            >
                                {i18next.t('timesheet:button.reset')}
                            </Button>
                        }

                        {this.state.timesheetId > 0 && this.state.canModify &&
                            <Button
                                loading={!this.state.isDeleteCompleted}
                                className={styles.deleteButton}
                                onClick={this.handleConfirmDelete}
                                variant="danger"
                            >
                                {i18next.t('timesheet:button.delete')}
                            </Button>
                        }
                    </FormControl>

                    <Dialog
                        open={this.state.openConfirmDelete}
                        onClose={this.handleCloseConfirmDelete}
                        aria-labelledby="draggable-dialog-title"
                    >
                        <DialogTitle id="draggable-dialog-title">
                            {i18next.t('timesheet:form.warning')}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {i18next.t('timesheet:message.confirmDelete')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseConfirmDelete} color="primary" variant="success" className={styles.buttonYesNo}>
                                {i18next.t('timesheet:button.no')}
                            </Button>
                            <Button autoFocus onClick={this.handleDeleteButtonClick} color="primary" variant="success" className={styles.buttonYesNo}>
                                {i18next.t('timesheet:button.yes')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={this.state.openConfirmReset}
                        onClose={this.handleCloseConfirmReset}
                        aria-labelledby="draggable-dialog-title"
                    >
                        <DialogTitle id="draggable-dialog-title">
                            {i18next.t('timesheet:form.warning')}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText className={styles.resetText}>
                                {format(i18next.t('timesheet:message.confirmReset'), this.state.selectedDate, this.state.expenseTypeDescription, this.state.total != undefined ? utils.toDisplayDecimal(this.state.total) : 0)}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseConfirmReset} color="primary" variant="success" className={styles.buttonYesNo}>
                                {i18next.t('timesheet:button.no')}
                            </Button>
                            <Button onClick={this.handleResetButtonClick} color="primary" variant="success" className={styles.buttonYesNo}>
                                {i18next.t('timesheet:button.yes')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <AlertAlgo ref={this.alert} />
                </div>
            </LoadingOverlay>
        );
    }
}

export default withNamespaces(['timesheet', 'error'], { wait: true })(TimesheetForm);